// extracted by mini-css-extract-plugin
export var modal = "outputModal-module--modal--RLjls";
export var inner = "outputModal-module--inner--33-jb";
export var modalContent = "outputModal-module--modalContent--tsyKa";
export var video = "outputModal-module--video--1w1DX";
export var modalClose = "outputModal-module--modalClose--voIIS";
export var active = "outputModal-module--active--2oGQ6";
export var modalInnerPop = "outputModal-module--modalInnerPop--33iEO";
export var close = "outputModal-module--close--21Hgs";